import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { contactForm } from "./contact-form";
import { recaptchaObject } from "./recaptcha";
require('parsley');

export class corporateTravelForm {
	private formEl:any = $('#corporate-travel--form');
	private contactBase:any = new contactForm();

	/**
	 * initialize all form inputs with focus and filled effects
	 * @return {any} [description]
	 */
	initTextInputs():any {
		let _self = this;
		let inputElArr:any = _self.formEl.find('input[type="text"], input[type="email"], textarea');

		_self.contactBase.initFormTextInputs(inputElArr);
	}

	/**
	 * [initSelectizeInputs description]
	 * @return {any} [description]
	 */
	initSelectizeInputs(): any {
		let _self = this;
		let inputSelectArr:any = $.makeArray(_self.formEl.find('select'));
		_self.contactBase.initSelectizeInputs(inputSelectArr);
	}

	validateForm(): any {
		let _self = this;

		_self.contactBase.validateForm(_self.formEl, function(validation: any) {
			// all your custom validation here
		},
		function(validation:any, formData:any){
			var url = _self.formEl.attr("action");
	    // success fuctions here
	    $.get(url, _self.formEl.serialize())
				.done((data:any) => {
	    		$('.form-content--wrapper').hide();
	    		$('.form-submission--success').show();
				})
				.fail((error:any) => {
	    		$('.form-content--wrapper').show();
	    		$('.form-submission--success').hide();
				});
		});
	}

	/**
	 * [initDatepickerInputs description]
	 * @return {any} [description]
	 */
	initDatepickerInputs(): any {
		let _self = this;
		let inputDateArr   = $('#contact-reservation--flightdate');
		let minDate:any = new Date();
		let maxDate:any = new Date((new Date().getFullYear() + 5).toString());

		_self.contactBase.initDatepickerInputs(inputDateArr, minDate, maxDate);
	}

	initRecaptcha():any {
		let _self = this;
		let _body = $('body');
		let recaptchaobj = new recaptchaObject();

		let recaptchaInfo:recaptchaInfo = {
			id: 'corporate-travel-form-recaptcha',
			cb: 'recaptchaCorporateSuccess',
			cbObj:	function () {
								(document.getElementById('corporate-travel-form-recaptcha') as HTMLInputElement).value = 'true';
							},
			displayId: 'contact-corporate--grecaptcha',
			formEl: _self.formEl
		};

		recaptchaobj.createRecaptchaField(recaptchaInfo);
	}
}

let scope:Element = document.querySelector('#corporate-travel--form');
if (scope){
	try {
	let corptravelform = new corporateTravelForm();
		corptravelform.initTextInputs();
		corptravelform.initSelectizeInputs();
		corptravelform.initDatepickerInputs();
		corptravelform.validateForm();
		//corptravelform.initRecaptcha();
	} catch(e) {console.error(e);}
}
